import { handlerApiError } from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import {
  BatchArchiveOrdersParams,
  BatchChangeOrderStatusParams,
  BatchCopyOrdersParams,
  BatchSplitOrdersParams,
  BatchUpdateConditionsParams,
  BatchUpdatePricesParams,
} from '../interfaces/orderBatchRepository.interfaces';
import { BatchChangeOrderStatusByActionType } from '../list/mass-actions/types/orderListMassActions.types';

const PATH = 'orders-batch';

const ordersBatchRepository = () => {
  const batchChangeOrderStatus = async (params: BatchChangeOrderStatusParams) =>
    handlerApiError(await restApi.patch(`${PATH}/change-order-status`, params));

  const batchChangeOrderStatusByAction = async (
    action: BatchChangeOrderStatusByActionType,
    params: BatchChangeOrderStatusParams,
  ) => handlerApiError(await restApi.patch(`${PATH}/change-order-status/${action}`, params));

  const batchArchiveOrders = async (params: BatchArchiveOrdersParams) =>
    handlerApiError(await restApi.patch(`${PATH}/archive-orders`, params));

  const batchUpdatePrices = async (params: BatchUpdatePricesParams) =>
    handlerApiError(await restApi.patch(`${PATH}/update-prices`, params));

  const batchUpdateConditions = async (params: BatchUpdateConditionsParams) =>
    handlerApiError(await restApi.patch(`${PATH}/update-conditions`, params));

  const batchSplitOrders = async (params: BatchSplitOrdersParams) =>
    handlerApiError(await restApi.patch(`${PATH}/split-orders`, params));

  const batchCopyOrders = async (params: BatchCopyOrdersParams) =>
    handlerApiError(await restApi.post(`${PATH}/copy-orders`, params));

  return {
    batchChangeOrderStatus,
    batchChangeOrderStatusByAction,
    batchArchiveOrders,
    batchUpdatePrices,
    batchUpdateConditions,
    batchSplitOrders,
    batchCopyOrders,
  };
};

export default ordersBatchRepository;
